import moment from 'moment'
import i18n from '../../i18n'

export const formatLatestScan = latestScan => {
  if (!latestScan) {
    return i18n.t('Never scanned')
  }
  const scanDate = moment(latestScan.created_at)
  const now = moment()
  const minutesDiff = now.diff(scanDate, 'minutes')
  if (minutesDiff < 60) {
    return i18n.t('{{minutes}} minutes ago', {minutes: minutesDiff})
  }
  const hoursDiff = now.diff(scanDate, 'hours')
  if (hoursDiff < 24) {
    return i18n.t('{{hours}} hours ago', {hours: hoursDiff})
  }
  const daysDiff = now.diff(scanDate, 'days')
  return i18n.t('{{days}} days ago', {days: daysDiff})
}

export const getEstimatedCost = rentalDetail => {
  if (!rentalDetail) {
    return 0
  }
  const daysLeft = rentalDetail?.rental_end_date ? moment(rentalDetail.rental_end_date).diff(moment(), 'days') : 0
  switch (rentalDetail.pricing_model) {
    case 'daily':
      return (rentalDetail.rate ?? 0) * daysLeft
    case 'weekly':
      return (rentalDetail.rate ?? 0) * Math.ceil(daysLeft / 7)
    case 'monthly':
      return (rentalDetail.rate ?? 0) * Math.ceil(daysLeft / 30)
    case 'yearly':
      return (rentalDetail.rate ?? 0) * Math.ceil(daysLeft / 365)
    case 'fixed':
      return rentalDetail.rate ?? 0
  }
  return 0
}

export const getPenalty = rentalDetail => {
  if (!rentalDetail) {
    return 0
  }
  const daysLate = rentalDetail?.rental_end_date ? moment().diff(moment(rentalDetail.rental_end_date), 'days') : 0
  if (daysLate <= 0) {
    return 0
  }
  return (rentalDetail.penalty_per_day ?? 0) * daysLate
}